import type { ReactNode } from "react";

/** "What it adds" (setup board ⑤): what the angle would change, shown across the
 *  Add-an-angle steps. Line 1 = how much of the library already fits (filled by the
 *  fit estimate; omitted when empty); line 2 = how many new papers the seeds bring. */
export function WhatItAdds({ fit, added }: { fit?: ReactNode; added: ReactNode }) {
  return (
    <section data-testid="what-it-adds" aria-label="What it adds" aria-live="polite"
      className="flex flex-col gap-1.5 rounded-md border bg-muted/40 p-3 text-sm">
      <h3 className="text-xs text-muted-foreground">What it adds</h3>
      {fit ? <div data-testid="what-it-adds-fit">{fit}</div> : null}
      <div data-testid="what-it-adds-new">{added}</div>
    </section>
  );
}
